import { Config } from '@customTypes/config'
import { fallbackLanguage } from './language'

const BIPA_REGION_VALUES = ['us', 'na']

export const checkIsRegionUS = (config: Config): boolean => {
  const {
    store: { region },
    store: { countryId },
  } = config

  let where: Array<string> = [region || '', countryId || '']

  if (config.analytics) {
    where = where.concat(config.analytics.storeRegion || '')
  }

  if (where.every(item => item === '')) {
    where = where.concat('us')
  }

  return where.some(current => BIPA_REGION_VALUES.includes(current.toLowerCase()))
}

export const checkIsRegionANZ = (config: Config): boolean => {
  const {
    store: { region },
    store: { countryId },
  } = config

  let where: Array<string> = [region || '', countryId || '']

  if (config.analytics) {
    where = where.concat(config.analytics.storeRegion || '')
  }

  return where.some(current => current.toLowerCase() === 'anz')
}

export const getRegion = (config: Config) => {
  const validRegion = ['US', 'EU', 'AU']

  const {
    store: { region },
    analytics,
  } = config || {}

  const { storeRegion } = analytics || {}

  const currentRegion = region || storeRegion || 'US'

  return validRegion.indexOf(currentRegion) > -1 ? currentRegion : 'EU' // meaning the region is the rest of the world so we use EU
}

export const getCountryCode = (locale: string) => {
  const parts = locale.split('-')

  return parts.length > 1 ? parts[1] : locale
}

export const isVMForKidsEnabled = (config: Config) => {
  const locale = config.locale || fallbackLanguage(config)
  const countryCode = getCountryCode(locale)
  const region = getRegion(config)

  // VM for kids is only available for US and CA
  if (
    ((countryCode === 'US' && region === 'US') || (countryCode === 'CA' && region === 'EU')) &&
    !!config.onSendCode &&
    !!config.onCodeVerify
  )
    return true
  else return false
}
